module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan4-2-99e509f141b59c3dcc831098ea47cbfd.webp";